/* Cart cookie auto-heal.
 *
 * Two failure modes leave customers with a cart that "never works" until
 * they manually clear cookies:
 *
 * 1. Duplicate cart cookies: a legacy `.balanceboard.pro`-scoped `cart`
 *    cookie (pre-i18n-migration it.* era) coexisting with the host-only
 *    `www` cookie — adds write to one cart while reads hit the other, so
 *    the cart always looks empty even though /cart/add.js returns 200.
 * 2. Stale/corrupted token: the `cart` cookie references a cart the
 *    backend can no longer serve, so /cart.js itself fails.
 *
 * Heal path: expire the offending cookies and reload so Shopify mints a
 * coherent cart. Anti-loop guard via sessionStorage; healthy visitors get
 * at most one /cart.js probe per session and no side effects.
 */
(function () {
  var CHECKED_FLAG = 'bbp:cart-heal:checked';
  var HEALED_FLAG = 'bbp:cart-heal:healed';
  var EXPIRY = '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  var ROOT_DOMAIN = location.hostname.replace(/^www\./, '');

  function cartCookieCount() {
    return (document.cookie.match(/(?:^|;\s*)cart=/g) || []).length;
  }

  function expireDomainScoped(names) {
    names.forEach(function (name) {
      document.cookie = name + EXPIRY + '; domain=.' + ROOT_DOMAIN;
    });
  }

  function expireEverywhere(names) {
    names.forEach(function (name) {
      document.cookie = name + EXPIRY;
    });
    expireDomainScoped(names);
  }

  function healOnce(healFn) {
    try {
      if (sessionStorage.getItem(HEALED_FLAG)) return;
      sessionStorage.setItem(HEALED_FLAG, '1');
    } catch (e) {
      return; // No guard available: skip rather than risk a reload loop.
    }
    healFn();
    location.reload();
  }

  var count = cartCookieCount();
  if (count === 0) return;

  // Mode 1 — duplicate cart cookies. Modern Shopify sets host-only cookies,
  // so the domain-scoped copy is the legacy one: drop it (and its legacy
  // domain-scoped companions) and keep the current host-only cart.
  if (count > 1) {
    healOnce(function () {
      expireDomainScoped(['cart', 'cart_sig', 'cart_ts', 'cart_ver', 'localization']);
      if (cartCookieCount() > 1) {
        // Domain-scoped expiry did not converge: full reset.
        expireEverywhere(['cart', 'cart_sig', 'cart_ts', 'cart_ver']);
      }
    });
    return;
  }

  // Mode 2 — single cookie, probe the backend once per session.
  try {
    if (sessionStorage.getItem(CHECKED_FLAG)) return;
    sessionStorage.setItem(CHECKED_FLAG, '1');
  } catch (e) {
    return;
  }

  fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
    .then(function (response) {
      if (!response.ok) return true;
      return response
        .json()
        .then(function () {
          return false;
        })
        .catch(function () {
          return true;
        });
    })
    .then(function (broken) {
      if (!broken) return;
      healOnce(function () {
        expireEverywhere(['cart', 'cart_sig', 'cart_ts', 'cart_ver']);
      });
    })
    .catch(function () {
      /* Network hiccup: leave everything untouched. */
    });
})();
